import { foundationMenuShadowOptions, Menu as FoundationMenu, foundationMenuTemplate as zeroMenuTemplate, } from '@genesislcap/foundation-ui';
import { zeroMenuStyles } from './menu.styles';
export const zeroMenuShadowOptions = foundationMenuShadowOptions;
/**
 * @tagname %%prefix%%-menu
 */
export class Menu extends FoundationMenu {
}
/**
 * The Zero Menu
 *
 * @public
 * @remarks
 * HTML Element: \<zero-menu\>
 */
export const zeroMenu = Menu.compose({
    baseName: 'menu',
    template: zeroMenuTemplate,
    styles: zeroMenuStyles,
    shadowOptions: zeroMenuShadowOptions,
});
